import { Item } from './Classes'

export default [
  new Item('Libram of Wrath', 'inv_misc_book_07', 'epic', 'Relic', 'Libram', null, null, null, null, ['Allows your Hammer of Wrath to be cast on targets with any amount of health, but reduces the damage by 95%.']),
  new Item('Totem of Tempest', 'inv_jewelry_amulet_06', 'epic', 'Relic', 'Totem', null, null, null, null, ['Reduces the threat of additional attacks from your Windury Weapon by 75%.']),
  new Item('Band of Guidance', 'inv_jewelry_ring_43', 'epic', 'Finger', null, null, null, null, null, ['Equip: Increases your chance to hit by 2%.', 'Equip: Increases your chance to hit with spells by 2%.']),
  new Item('Daybreak', 'inv_hammer_04', 'epic', 'Two-hand', 'Mace', 'Speed 3.00', '131 - 255 Damage', '(59.33 damage per second)', null, ['Chance on hit: physical damage taken by target increased by 10% for 8 sec.']),
  new Item('Idol of the World Tree', 'inv_qirajidol_night', 'rare', 'Relic', 'Idol', null, null, null, null, ['Increases the duration of your Rejuvenation and Regrowth spells by 4 sec.']),
  new Item('Jewel of Synergy', 'inv_jewelry_ring_64', 'epic', 'Trinket', null, null, null, null, null, ['Increases your spell damage by 10% for 8 sec after dealing damage from three different magic schools within 3 sec.']),
  new Item('Book of Command', 'warlock_grimoireofcommand', 'epic', 'Trinket', null, null, null, null, null, ['Use: Increases the damage and critical strike chance of your active pets and summons by 25% for 15 sec. (3 min cooldown)']),
  // new Item('Totem of Tidal Orbs', 'inv_qirajidol_life', 'epic', 'Relic', 'Totem', null, null, null, null, ['Damage from your Lightning Shield returns mana equal to 60% of the damage dealt.']),
  // new Item(
  //   'Breastplate of Victory',
  //   'inv_chest_plate07',
  //   'rare',
  //   'Chest',
  //   'Mail',
  //   null,
  //   null,
  //   null,
  //   { armor: 207, stamina: 0, strength: 0, intellect: 0, spirit: 0, agility: 0 },
  //   ['Gain 10 rage and 10% health after killing an opponent that yields experience or honor.'],
  //   'Warrior',
  //   27
  // ),
]
